/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-formly-repeat-section',
  templateUrl: './repeating-section.html',
  styleUrl: './repeating-section.scss',
  imports: [
    FormlyModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatError,
    FormsModule,
    MatInput,
    MatIconButton,
    MatIcon,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyRepeatTypeComponent
  extends FieldArrayType
  implements OnInit
{
  ngOnInit(): void {
    if (!this.field.fieldGroup || this.field.fieldGroup.length === 0) {
      this.add();
    }
  }

  /**
   * Finds the sub-field that contains the actual key and type properties
   */
  getActualField(nestedGroup: any): any {
    if (!nestedGroup) return null;
    if (nestedGroup.key) return nestedGroup;

    if (nestedGroup.fieldGroup?.length) {
      return nestedGroup.fieldGroup.find((f: any) => !!f.key) ?? null;
    }
    return null;
  }

  /**
   * Returns true if the field requires Formly rendering (e.g. file upload or custom type)
   */
  isCustomOrFileField(nestedGroup: any): boolean {
    const actual = this.getActualField(nestedGroup);
    if (!actual) return false;

    const inputType = actual.props?.type || actual.type;
    return (
      inputType === 'file' || actual.type === 'file' || actual.type === 'iban'
    );
  }

  getGroupControl(groupIndex: number, nestedGroup: any): FormControl | null {
    const group = this.formControl.at(groupIndex) as FormGroup;
    if (!group) return null;

    const actualField = this.getActualField(nestedGroup);
    if (actualField?.key) {
      const ctrl = group.get(String(actualField.key));
      if (ctrl) return ctrl as FormControl;
    }

    return null;
  }

  /**
   * Reads label strictly from within this specific nested group/item
   */
  getFieldLabel(nestedGroup: any): string {
    if (!nestedGroup) return '';

    if (nestedGroup.props?.label) {
      return nestedGroup.props.label;
    }

    if (nestedGroup.fieldGroup?.length) {
      for (const subField of nestedGroup.fieldGroup) {
        if (subField.props?.label) {
          return subField.props.label;
        }
      }
    }

    return '';
  }

  get maxItems(): number | undefined {
    return (this.props['max'] ?? this.props.max) as number | undefined;
  }

  get isMaxReached(): boolean {
    if (this.maxItems === undefined) return false;
    return (this.field.fieldGroup?.length ?? 0) >= this.maxItems;
  }
}
